import {API} from "@/Composables/api";

const getGroupQuestionResponses = async (group: string, question: string, params = {}) => {
    return API.get(route("groups.questions.responses.index", {group, question}), params);
};

const getGroupQuestionResponse = async (group: string, question: string, response: string, params = {}) => {
    return API.get(
        route("groups.questions.responses.show", {
            group,
            question,
            response,
        }),
        params,
    );
};

const storeGroupQuestionResponse = async (group: any, question: any, response: any, params = {}) => {
    return API.post(route("groups.questions.responses.store", [group, question]), params, response);
};

const updateGroupQuestionResponse = async (group: any, question: any, response: any, params = {}) => {
    return API.put(route("groups.questions.responses.update", [group, question, response?.id]), params, response);
};

const deleteGroupQuestionResponse = async (group: any, question: any, response: any) => {
    return API.delete(route("groups.questions.responses.destroy", [group, question, response]));
};

const getGroupQuestionResponseVotes = async (group: any, question: any, response: any, params = {}) => {
    return API.get(
        route("groups.questions.responses.votes", {
            group,
            question,
            response,
        }),
        params,
    );
};

const voteOnGroupQuestionResponse = async (
    group: string,
    question: string,
    response: string,
    vote: string,
    params = {},
) => {
    return API.put(route("groups.questions.responses.vote", {group, question, response}), params, {vote: vote});
};

export {
    getGroupQuestionResponses,
    getGroupQuestionResponse,
    storeGroupQuestionResponse,
    updateGroupQuestionResponse,
    deleteGroupQuestionResponse,
    getGroupQuestionResponseVotes,
    voteOnGroupQuestionResponse,
};
